<template>
  <pi-content className="white" class="my-order-details">
    <!-- <view class="container-details ios-padding-bottom"> -->
  <div class="order-detail-top">
    <div class="order-detail-all">
      <div class="order-detail-title mgt20 mgb10">
        <div class="order-detail-left">
          <div class="order-detail-no">订单号{{orderInfo.orderNo }}</div>
        </div>
        <div class="order-detail-right">{{orderInfo.orderStatusDesc }}</div>
      </div>
      <div class="order-detail-name">
        {{orderInfo.staName }}
      </div>
      <div class="order-detail-title mgb10">
        <div class="order-detail-left">
          <div class="order-left-top">电桩</div>
        </div>
        <div class="order-detail-right">{{orderInfo.pileName }}</div>
      </div>
      <div class="order-detail-title mgb10">
        <div class="order-detail-left">
          <div class="order-left-top">枪号</div>
        </div>
        <div class="order-detail-right">{{orderInfo.gunName}}枪</div>
      </div>
      <div class="order-detail-title mgb10">
        <div class="order-detail-left">
          <div class="order-left-top">时段</div>
        </div>
        <div class="order-detail-right">{{orderInfo.chargeBeginTime }} - {{orderInfo.chargeEndTime }}</div>
      </div>
      <div class="order-detail-title mgb10">
        <div class="order-detail-left">
          <div class="order-left-top">停止原因</div>
        </div>
        <div class="order-detail-right">{{orderInfo.stopReason }}</div>
      </div>
      <div class="order-detail-title mgb10">
        <div class="order-detail-left">
          <div class="order-left-top">充电策略</div>
        </div>
        <div class="order-detail-right">{{orderInfo.chargingModelDesc }}</div>
      </div>
      <div class="order-detail-title mgb10">
        <div class="order-detail-left">
          <div class="order-left-top">充电类型</div>
        </div>
        <div class="order-detail-right">{{orderInfo.consumptionPatternDesc }}</div>
      </div>
      <div class="order-detail-title mgb10">
        <div class="order-detail-left">
          <div class="order-left-top">车牌号码</div>
        </div>
        <div class="order-detail-right">{{orderInfo.carNo || '--'  }}</div>
      </div>
      <div class="order-detail-title mgb10">
        <div class="order-detail-left">
          <div class="order-left-top">车牌Vin码</div>
        </div>
        <div class="order-detail-right">{{orderInfo.carVin || '--' }}</div>
      </div>
    </div>
  </div>
  <div class="order-detail-middle">
     <div class="order-detail-all">
      <div class="order-detail-title    mgb10 mgt20">
        <div class="order-detail-left">
          <div class="order-left-top">电量(度)</div>
        </div>
        <div class="order-right-big">{{orderInfo.chargeElect }}</div>
      </div>
      <div class="order-detail-title mgb10">
        <div class="order-detail-left">
          <div class="order-left-top">充电时长</div>
        </div>
        <div class="order-right-big">{{orderInfo.chargeDuration}}</div>
      </div>
      <div class="order-detail-title mgb10">
        <div class="order-detail-left">
          <div class="order-left-top">电费(元)</div>
        </div>
        <div class="order-right-big">{{orderInfo.chargeAmount }}</div>
      </div>
      <div class="order-detail-title mgb10">
        <div class="order-detail-left">
          <div class="order-left-top">服务费(元)</div>
        </div>
        <div class="order-right-big">{{orderInfo.serviceAmount}}</div>
      </div>
    </div>
  </div>
  <div class="order-detail-bottom" v-if="orderInfo.delayDuration">
     <div class="order-detail-all">
      <div class="order-detail-title mgb10">
        <div class="order-detail-left">
          <div class="order-left-top">延时时长</div>
        </div>
        <div class="order-right-big">{{orderInfo.delayDuration}}</div>
      </div>
      <div class="order-detail-title">
        <div class="order-detail-left">
          <div class="order-left-top">延时费(元)</div>
        </div>
        <div class="order-right-big">{{orderInfo.delayAmount}}</div>
      </div>
    </div>
  </div>
  <div class="discount-content">
    <!-- <div class="row-discount" v-if="orderInfo.totalDiscount">
      <div class="total-text">共优惠(元):</div>
      <div class="row-value">{{orderInfo.totalDiscount}}</div>
    </div> -->
    <div class="row-discount" v-if="orderInfo.priceDiscountAmount">
      <div class="activity-discount">
        <img class="discount-icon" src="../../assets/integral-icon/activity-discount.png" alt="" />
        活动调价
      </div>
      <div class="row-value">-{{orderInfo.priceDiscountAmount}}</div>
    </div>
    <div class="row-discount" v-if="orderInfo.vipDiscountAmount">
      <div class="member-discount">
        <pi-user-tag :vipType="orderInfo.vipLevel"></pi-user-tag>
      </div>
      <div class="row-value">-{{orderInfo.vipDiscountAmount}}</div>
    </div>
    <div class="row-discount" v-if="orderInfo.couponDiscountAmount">
      <div class="activity-discount coupon">
        <img class="discount-icon" src="../../assets/integral-icon/coupon-discount.png" alt="" />
        <template v-if="orderInfo.rule && orderInfo.rule.discount">
          满{{orderInfo.rule.discount.condition}}减{{orderInfo.rule.discount.discount}}
        </template>
        
      </div>
      <div class="row-value">-{{orderInfo.couponDiscountAmount}}</div>
    </div>
    <div class="row-discount total-row">
      <div class="total-text">总计(元):</div>
      <div class="row-value">{{orderInfo.transactionAmount}}</div>
    </div>
  </div>
  <div class="order-detail-service">
    <div class="order-detail-all">
      <div class="order-detail-title mgb10 mgt20" bindtap="goTel">
        <div class="order-detail-left">
        </div>
        <div class="order-right-tips">
          <img class="charging-customer-service" src="../../assets/image/customer-service.png"
                 alt=""/>
          <!-- <text> -->
            如有疑问请联系场站负责人       
          <!-- </text> -->
        </div>
      </div>
    </div>
  </div>
  <div class="go-close">
    <pi-button type="primary" block @click="goClose">关闭</pi-button>
  </div>

  </pi-content>
</template>

<script>
import { getOrderDetails } from "../../common/api";
import UserTag from "@/view/my/components/pi-user-tag";
export default {
  name: "my-order-details",
  components: {
    [UserTag.name]: UserTag
  },
  data() {
    return {
      stopReason: "",
      orderInfo: {},
      priceList: [],
      delayPriceList: [],
    };
  },
  methods: {
    getDetails() {
      getOrderDetails({
        orderNo: this.$route.query.orderNo,
      })
        .then((data) => {
          if (data.status === 0 && data.data) {
            this.orderInfo = data.data[0];
            // if (this.orderInfo.handleFlag === 1) {
            //   // this.stopReason = this.orderInfo.pileRecord? this.orderInfo.pileRecord.stopReason: null;
            //   this.initPriceList(this.orderInfo.pileRecord);
            // }else if (this.orderInfo.handleFlag === 2){
            //   this.stopReason = this.orderInfo.platformRecord? this.orderInfo.platformRecord.stopReason: null;
            //   this.initPriceList(this.orderInfo.platformRecord);
            // }
          } else {
            throw new Error(data.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    initPriceList(record) {
      this.priceList = [];
      if (record && record.slotDetail) {
        record.slotDetail.forEach((item) => {
          this.priceList.push({
            price: item.slotType + item.chargePrice,
            power: item.chargeElect,
          });
        });
      }
      if (
        this.orderInfo.delayRecordInfoVo &&
        this.orderInfo.delayRecordInfoVo.delayRecordDetailVos
      ) {
        this.orderInfo.delayRecordInfoVo.delayRecordDetailVos.forEach(
          (item) => {
            this.delayPriceList.push({
              duration: item.duration,
              freeDuration: item.freeDuration,
              delayPrice: item.delayPrice,
            });
          }
        );
      }
    },
    goClose(){
      this.$common.goBack();
    }
  },
  mounted() {
    this.$common.bodyAddBg();
    this.getDetails();
  },
  destroyed() {},
  computed: {},
  beforeDestroy() {
    this.$common.removeBodyBg();
  },
};
</script>

<style lang="less">
@import "../../assets/less/old/var.less";

.my-order-details {
.container-details{ 
  background: #EFEFF4;
  min-height: 100%;
  box-sizing: border-box;
}
.order-detail-top{
  background: #FFFFFF;

}
.order-detail-all{
  margin: 0 0.2rem;
  text-align: left;
}
.mgt20{
  margin-top: 0.2rem;
}
.mgb10{
  margin-bottom: 0.1rem;
}
.order-detail-title{
  width: 7.10rem;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
}
.order-detail-left{
  flex: 1;
}
.order-detail-no{
  height: 0.4rem;
  font-size: 0.28rem;
  font-weight: 500;
  color: #000000;
  line-height: 0.4rem;
  
}
.order-detail-right{
  height: 0.33rem;
  font-size: 0.24rem;
  font-weight: 400;
  color: #999999;
  line-height: 0.33rem;
}
.order-detail-name{
  height: 0.4rem;
  font-size: 0.28rem;
  font-weight: 500;
  color: #000000;
  line-height: 0.4rem;
}
.order-left-top{
  height: 0.4rem;
  font-size: 0.28rem;
  font-weight: 400;
  color: #666666;
  line-height: 0.4rem;
}
.order-detail-middle{
  height: 2.3rem;
  background: #FFFFFF;
  margin: 0.1rem 0 0.01rem 0;
}
.order-right-big{
  height: 0.4rem;
  font-size: 0.28rem;
  font-weight: 500;
  color: #000000;
  line-height: 0.4rem;
}
.order-detail-bottom{
  background: #FFFFFF;
  margin-top: 0.01rem;
  padding: 0.2rem 0 ;
}
.order-detail-down{
  background: #FFFFFF;
  margin-top: 0.01rem;
  padding: 0.2rem 0;
}
.order-detail-money{
  height: 0.96rem;
  background: #FFFFFF;
  margin-top: 0.1rem;
}
.order-right-money{
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
}
.order-money-left{
  height: 0.4rem;
  font-size: 0.28rem;
  font-weight: 400;
  color: #666666;
  line-height: 0.4rem; 
  margin-right: 0.1rem;
}
.order-money-right{
  height: 0.56rem;
  font-size: 0.4rem;
  font-weight: 500;
  color: #14CC80;
  line-height: 0.56rem;
}
.money-total-no{
  margin-left: 0.1rem;
  font-size: 0.24rem;
  color: #999;
  text-decoration: line-through;
}
.order-detail-service{
  height: 0.96rem;
  background: #FFFFFF;
  margin-top: 0.01rem;
}
.charging-customer-service{
  width: 0.54rem;
  height: 0.54rem;
  margin-right: 0.1rem;
}
.order-right-tips{
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  height: 0.4rem;
  font-size: 0.28rem;
  font-weight: 400;
  color: #666666;
  line-height: 0.4rem;
}
.go-close{
  margin:0.2rem 0.4rem 0.1rem 0.4rem
}

.discount-content{
  text-align: right;
  background-color: #fff;
  padding: 0.12rem;
}
.row-discount{
  font-size:0.28rem;
  line-height: 0.4rem;
  margin-top: 0.22rem;
}
.row-discount.total-row{
  margin-top: 0.37rem;
}
.row-discount.total-row .row-value{
  font-size: 0.36rem;
}
.member-discount{
  display: inline-block;
  vertical-align: top;
}
.member-discount img{
  width: 1.12rem;
  height: 0.38rem;
  margin-right: 0;
}
.total-text{
  color: #999;
  display: inline-block;
  vertical-align: top;
}
.row-value{
  display: inline-block;
  vertical-align: top;
  min-width: 1rem;
  color: #14CC80;
}
.activity-discount{
  padding: 0 0.07rem;
  background-color: #999999;
  font-size: 0.16rem;
  line-height: 0.28rem;
  height: 0.28rem;
  color: #fff;
  border-radius: 0.14rem;
  display: inline-block;
  min-width: 1.12rem;
  text-align: center;
  box-sizing: border-box;
}
.activity-discount.coupon{
  background-color: #999999;
  background: linear-gradient(180deg, #FEC446 0%, #F99130 100%);

}
.discount-icon{
  width: 0.28rem;
  height: 0.28rem;
  vertical-align: top;
}
 
}
</style>
